module.exports = __webpack_public_path__ + "static/media/wardah_3.02105dd6.jpg";